import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";


import { CustomCard } from "../../components/Card/CustomCard";
import { Url } from '../../shared/Url';
import Post from '../../shared/Post';
import logo from "../../assets/img/logo-TAD-d.png";

let statusUser=0
class VerifyUser extends Component {
    state = {
        status: 0,
        titulo: "",
        mensaje: "Validando...",
        color: "#000"
    }

    constructor (props) {
        super (props);
        this.consultaDatos();
    }

    consultaDatos = () => {
        let Content = this.getGET();
        Post(`${Url}verifyUser`, Content, (resp) => {
            let data = JSON.parse(resp);
            statusUser =  data.status
            this.setState ({
                status: data.status,
                titulo: data.titulo,
                mensaje: data.mensaje
            });
        });
    }

    getGET = () => {
        let loc = document.location.href;
        if(loc.indexOf('?') > 0){
            let getString = loc.split('?')[1];
            let GET = getString.split('&');
            let get = {};
            for(let i = 0, l = GET.length; i < l; i++){
                let tmp = GET[i].split('=');
                get[tmp[0]] = unescape(decodeURI(tmp[1]));
            }
            return get;
        }
    }

    titulo = () => (
        <Row>
            <Col md={3}>
                <img src={logo} alt="User" className="img img-responsive"
                        style={{height:"auto", width:35}}/>
            </Col>
            <Col md={9} align="right">
                <span>Activación de Usuarios</span>
                <div className="text-muted" style={{fontSize:12, marginTop:-10}}>Estado de tu activación</div>
            </Col>
        </Row>
    )

    contenido = () => {
        let button = "";
        let clase = ""

        if (statusUser === "0"){
            button = <Link to="/home">
                         <button className="btn btn-primary" style={{borderWidth:1,}}><i className="fa fa-home"></i> Ir al Inicio</button>
                     </Link>
            clase = "custom-alert-danger"
        }else if (statusUser === "1"){
            clase = "custom-alert-info"
            button = <Link to="/login">
                        <button className="btn btn-primary" style={{borderWidth:1,}}><i className="fa fa-sign-in"></i> Iniciar Sesión</button>
                     </Link>
        }

        return(
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <div className={clase} style={{padding: 5}}>
                            {this.state.mensaje}
                        </div>
                    </Col>
                    <Col md={12} align="right" className="custom-mt-10">
                        {button}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    mensaje = () => {
        return (
            <React.Fragment>
                <div className="login-content" style={{position:"fixed"}}>
                    <div className="wrapper2">
                        <div className="wave one"></div>
                        <div className="wave dos"></div>
                        <div className="wave tres"></div>
                    </div>
                    <Row>
                        <Col md={3}></Col>
                        <Col md={6}>
                            <div style={{/* boxShadow: "1px 1px 2px #000",  */borderRadius: "4px 4px",}}>
                                <CustomCard
                                    title={this.titulo()}
                                    category=""
                                    color="#a80012"
                                    content={this.contenido()}
                                />
                            </div>
                        </Col>
                        <Col md={3}></Col>
                    </Row>
                    <div align="center" style={{color:"#777"}}>
                        &copy; {new Date().getFullYear()} Diseñado y Desarrollado por <a href = "https://www.eyss-dev.com/">
                        <span style = {{color:"#4885ed"}}>E</span>
                        <span style = {{color:"#dc3d36"}}>Y</span>
                        <span style = {{color:"#f4c230"}}>S</span>
                        <span style = {{color:"#62bc55"}}>S</span>
                        </a>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            this.mensaje()  
        );
    }
}
 
export default VerifyUser;



// WEBPACK FOOTER //
// ./src/site/Views/VerifyUser.jsx